export const ErrorMojo = ({ className }: { className: string }) => (
  <svg className={className} viewBox="0 0 295 358" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.08 358C234.147 358 295 351.085 295 342.555C295 334.024 234.147 327.109 159.08 327.109C84.0129 327.109 23.1592 334.024 23.1592 342.555C23.1592 351.085 84.0129 358 159.08 358Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M226.913 226.046C226.913 226.046 254.59 226.772 266.09 249.112C266.09 249.112 256.925 253.952 262.077 260.377C265.699 265.275 267.319 262.011 268.403 263.431C269.454 264.808 271.944 269.984 279.453 268.226C281.155 267.827 282.323 265.533 282.33 264.828C282.33 264.828 286.889 264.637 287.896 261.174C287.896 261.174 292.478 256.155 291.318 252.245C291.318 252.245 285.561 202.261 244.908 190.378L226.913 226.046Z"
      fill="#94C93D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M267.989 257.089C267.989 257.089 270.615 260.319 268.403 263.431C268.403 263.431 269.043 260.285 267.989 257.089Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M265.309 257.919C265.309 257.919 269.129 259.569 268.606 263.351C268.606 263.351 267.72 260.266 265.309 257.919Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M233.433 213.124V226.851C239.599 228.004 249.053 230.805 256.942 237.567C259.618 229.823 263.359 215.295 261.504 198.392C256.748 195.016 251.253 192.232 244.908 190.378L233.433 213.124Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M161.857 28.8278C161.857 28.8278 118.308 13.7366 103.066 13.0074C87.8238 12.2792 80.0915 20.0488 87.8238 28.8278C95.0704 37.0546 100.583 33.2595 104.518 53.0791L161.857 41.4217V28.8278Z"
      fill="#94C93D"
    />
    <mask
      id="mask0_0_1245"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="105"
      width="64"
      height="36"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M0 105.529H63.8721V140.749H0V105.529Z" fill="white" />
    </mask>
    <g mask="url(#mask0_0_1245)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.4526 117.679C61.4526 117.679 28.5488 99.7076 0 107.479C0 107.479 19.3548 160.421 63.8722 132.736L61.4526 117.679Z"
        fill="#2D292A"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.6135 157.507C71.6135 157.507 53.7101 191.021 15 178.878C15 178.878 33.4924 148.305 56.6667 136.635L71.6135 157.507Z"
      fill="#221E1F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.615 48.1636C115.511 40.9033 108.823 34.7709 101.159 30.3232C96.9896 27.9038 92.505 25.9544 88.7792 22.8929C87.5352 21.8719 86.3933 20.6754 85.414 19.3708C84.1386 22.0605 84.7733 25.3642 87.8242 28.8278C95.0701 37.0546 100.584 33.2595 104.518 53.0791L121.579 49.6105C121.271 49.1174 120.946 48.6347 120.615 48.1636Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M233.23 62.3074C222.584 34.1363 193.551 31.2221 193.551 31.2221C134.518 20.5361 82.917 48.6813 73.0657 55.5076C61.1141 63.7896 46.4528 76.8789 53.2274 99.2216C60.0013 121.564 66.7753 240.078 66.7753 240.078C66.7753 240.078 64.8399 254.649 68.7113 265.335C69.7882 268.309 74.5435 271.583 80.8377 274.761H80.8344L91.4533 340.863H135.717C135.717 340.863 137.18 327.385 118.309 325.563C118.309 325.563 126.643 308.633 129.625 290.856C140.394 291.286 165.237 291.974 195.047 290.813L203.087 340.863H247.351C247.351 340.863 248.814 327.385 229.942 325.563C229.942 325.563 243.523 297.97 242.205 276.246C250.323 267.605 253.062 255.342 253.552 240.078C254.52 209.964 243.875 90.4785 233.23 62.3074Z"
      fill="#94C93D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.46 181.529C94.46 181.529 109.944 181.289 113.331 199.44C113.331 199.44 108.008 190.638 94.46 181.529Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M195.454 283.126L129.625 290.857C140.393 291.286 165.237 291.974 195.047 290.813L203.087 340.863H218.493L211.737 295.622C210.559 287.729 203.352 282.198 195.454 283.126Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M219.922 58.6977C185.809 44.6452 124.84 54.5363 111.05 58.6977C97.2588 62.8596 83.4682 73.4788 85.6457 58.6977C86.5682 52.4351 99.4782 44.3242 114.052 37.0549C92.9733 43.5789 77.9272 52.1378 73.0649 55.5077C61.1133 63.7891 46.4515 76.879 53.2266 99.2217C55.9417 108.178 58.6573 132.594 60.9368 158.631C119.602 100.916 214.814 96.6181 214.814 96.6181L219.922 58.6977Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.5098 12.9603C51.5098 6.10759 57.0442 0.552246 63.8716 0.552246C70.6991 0.552246 76.2335 6.10759 76.2335 12.9603C76.2335 19.8136 70.6991 25.369 63.8716 25.369C57.0442 25.369 51.5098 19.8136 51.5098 12.9603Z"
      fill="#94C93D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.8432 146.649C59.8432 146.649 101.895 106.022 152.561 99.2219C203.229 92.4215 241.264 99.2219 241.264 99.2219C241.264 99.2219 249.681 67.1646 233.229 62.3076C216.777 57.4506 177.724 56.5151 133.551 65.7078C93.8724 73.9644 53.227 99.2219 53.227 99.2219C53.227 99.2219 45.1693 133.85 59.8432 146.649Z"
      fill="#221E1F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.4592 268.833C82.6328 254.482 75.7943 236.649 74.9832 218.043L71.6135 140.749L59.8428 146.649V146.65C63.8101 188.225 66.7744 240.078 66.7744 240.078C66.7744 240.078 64.839 254.649 68.7099 265.334C69.7873 268.309 74.5426 271.583 80.8368 274.76L80.8335 274.76L91.4524 340.863H94.4592V268.833Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.5283 13.3206C51.7202 20.0056 57.1659 25.369 63.872 25.369C70.0973 25.369 75.2331 20.7448 76.0927 14.7344C66.3324 16.5321 58.122 15.4934 51.5283 13.3206Z"
      fill="#7FAB35"
    />
    <path
      d="M145.09 122.927L156.565 129.87L145.09 135.771"
      stroke="#221E1F"
      strokeWidth="2.9007"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M225.652 116.018L216.005 125.35L228.5 128.54"
      stroke="#221E1F"
      strokeWidth="2.9007"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g style={{ mixBlendMode: "multiply" }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.582 160.998C102.582 175.017 113.903 186.382 127.87 186.382C141.836 186.382 153.158 175.017 153.158 160.998C153.158 146.979 141.836 135.615 127.87 135.615C113.903 135.615 102.582 146.979 102.582 160.998Z"
        fill="url(#paint0_radial_0_1245)"
      />
    </g>
    <g style={{ mixBlendMode: "multiply" }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.25 152.268C224.25 166.287 235.571 177.652 249.538 177.652C249.801 177.652 250.059 177.633 250.319 177.624C248.919 161.238 247.142 143.75 245.127 127.295C233.268 129.393 224.25 139.762 224.25 152.268Z"
        fill="url(#paint1_radial_0_1245)"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.725 164.655C159.725 164.655 176.281 156.533 190.329 155.654C204.377 154.773 214.452 160.129 222.384 157.223C230.316 154.318 231.652 144.31 223.892 139.344C216.132 134.377 210.96 132.7 190.978 133.489C170.996 134.278 154.013 142.708 151.167 151.225C148.323 159.744 152.013 167.953 159.725 164.655Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.858 141.195C165.858 141.195 170.147 154.1 168.968 158.947C168.968 158.947 174.702 150.359 165.858 141.195Z"
      fill="#E2E2E2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M188.298 135.516C188.298 135.516 192.587 148.42 191.408 153.267C191.408 153.267 197.142 144.68 188.298 135.516Z"
      fill="#E2E2E2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M209.938 138.3C209.938 138.3 214.226 151.205 213.047 156.051C213.047 156.051 218.781 147.464 209.938 138.3Z"
      fill="#E2E2E2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.487 115.809C151.487 115.809 154.625 128.661 161.64 124.532L151.487 115.809Z"
      fill="#729926"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M221.764 108.951C221.764 108.951 219.057 121.902 211.908 118.012L221.764 108.951Z"
      fill="#729926"
    />
    <g style={{ mixBlendMode: "multiply" }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.029 124.208C164.786 127.58 168.073 130.334 171.4 130.86C174.728 131.388 178.072 130.334 181.346 129.539C188.79 127.733 196.549 127.236 204.161 128.076C222.377 130.089 214.875 108.951 195.971 105.789C173.636 102.053 165.774 113.843 165.029 124.208Z"
        fill="url(#paint2_radial_0_1245)"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.1265 227.957C98.1265 227.957 65.8667 228.802 52.4622 254.841C52.4622 254.841 63.1445 260.483 57.1392 267.973C52.9187 273.681 51.0291 269.877 49.7664 271.531C48.5411 273.136 45.6386 279.17 36.8862 277.12C34.9022 276.656 33.5403 273.982 33.5331 273.16C33.5331 273.16 28.2192 272.937 27.0459 268.901C27.0459 268.901 21.705 263.051 23.0559 258.494C23.0559 258.494 29.7659 200.232 77.1517 186.382L98.1265 227.957Z"
      fill="#94C93D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.2474 264.14C50.2474 264.14 47.1871 267.904 49.7655 271.531C49.7655 271.531 49.0189 267.865 50.2474 264.14Z"
      fill="#7FAB35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.3722 265.108C53.3722 265.108 48.9197 267.03 49.529 271.439C49.529 271.439 50.5617 267.843 53.3722 265.108Z"
      fill="#7FAB35"
    />
    <defs>
      <radialGradient
        id="paint0_radial_0_1245"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(127.87 160.998) scale(25.2878 25.4697)"
      >
        <stop stopColor="#FF698F" />
        <stop offset="1" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_0_1245"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(237.285 152.473) scale(13.0346 25.2638)"
      >
        <stop stopColor="#FF698F" />
        <stop offset="1" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_0_1245"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(189.804 118.042) scale(24.7876 13.0043)"
      >
        <stop stopColor="#FF698F" />
        <stop offset="1" stopColor="white" />
      </radialGradient>
    </defs>
  </svg>
);
